import {TypeLieu} from './TypeLieu';
import {TypeObjCPV} from './TypeObjCPV';
import {TypeFournitures} from './TypeFournitures';
import {TypeTravaux} from './TypeTravaux';
export class TypeDescMarche {
	public isLieuExecutionLivraison: boolean;

	public lieuExecution: TypeLieu;

	public marcheTravaux: TypeTravaux;

	public lieuExecutionLivraison: TypeLieu;

	public marcheServices: string;

	public cpv: TypeObjCPV;

	public marcheFournitures: TypeFournitures;

	public objet: string;

	public lieuLivraison: TypeLieu;

	constructor() {
		this.lieuExecution = new TypeLieu();
		this.marcheTravaux = new TypeTravaux();
		this.lieuExecutionLivraison = new TypeLieu();
		this.marcheServices = '';
		this.cpv = new TypeObjCPV();
		this.marcheFournitures = new TypeFournitures();
		this.objet = '';
		this.lieuLivraison = new TypeLieu();
		this.isLieuExecutionLivraison = true;
	}
}
